export const readingParts=[
 {id:'perception',chapters:['rendering-worlds','camera-guide','audio-guide']},
 {id:'movement',chapters:['motion-guide','character-physics','fluid-guide','destruction-guide','ballistics-guide']},
 {id:'interaction',chapters:['game-feel','crowd-navigation']},
 {id:'shared-world',chapters:['network-play','online-worlds']}
];
export const readingOrder=readingParts.flatMap(part=>part.chapters);
export const chapterImages={
 'rendering-worlds':'simulation-lab','camera-guide':'camera-work','audio-guide':'audio-worlds',
 'motion-guide':'motion-worlds','character-physics':'simulation-lab','fluid-guide':'fluid-worlds',
 'destruction-guide':'destruction','ballistics-guide':'ballistics-worlds','game-feel':'game-feel',
 'crowd-navigation':'simulation-lab','network-play':'online-worlds','online-worlds':'online-worlds'
};
